<template>
    <div class="content">
        <router-view></router-view>
        <div class="content-body">
            <div class="widgets">
              <div class="widgets-wrapper">
                <ContractStatsWidget title="Rapport des ventes" period="current_month" class-name="fullx"></ContractStatsWidget>
                <CommissionStatsWidget title="Commissions" period="current_month" class-name="fullx"></CommissionStatsWidget>
              </div>
            </div>
        </div>
    </div>
</template>
<script>

    import Header from '../../layouts/Header.vue'
    import ContractStatsWidget from './contract/ContractStatsWidget.vue'
    import CommissionStatsWidget from './protractor/CommissionStatsWidget.vue'

    export default {
        name: 'Dashboard',
        data () {
            return {
                profiles: null,
                msg: 'Page FirstRoute'
            }
        },
        mounted: function(){

        },
        components: {
            'app-header': Header,
            'ContractStatsWidget' : ContractStatsWidget,
            'CommissionStatsWidget' : CommissionStatsWidget
        },
        methods: {
            increment: function () {
                this.$store.commit('increment')
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/modules/serevita/Dashboard.vue